import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import {
  computed,
  PropType,
} from 'vue';
import {
  useRouter,
} from 'vue-router';
import HeaderTextLinkButton from '@/components/NavBar/HeaderTextLinkButton.vue';
import {
  clientBaseUrl,
} from '@/helpers';
import {
  Navigation,
  NavigationChild,
} from '@/type';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationMenu',
  props: {
  navigation: {
    type: Object as PropType<Navigation>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const router = useRouter();



const route = computed(() => {
  if (!props.navigation.url) {
    return undefined;
  }
  if (props.navigation.url.startsWith(clientBaseUrl)) {
    return props.navigation.url.replace(clientBaseUrl, '') || '/';
  }
  return undefined;
});

const url = computed(() => {
  if (!props.navigation.url || route) {
    return undefined;
  }
  return props.navigation.url;
});

function getUrl(child: NavigationChild): string | undefined {
  return child.url.startsWith(clientBaseUrl)
    ? undefined : child.url;
}

function getRoute(child: NavigationChild): string | undefined {
  return child.url.startsWith(clientBaseUrl)
    ? child.url.replace(clientBaseUrl, '') || '/'
    : undefined;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.navigation.children.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.navigation.children, (child, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `${child.name}_${index}`
          }, [
            _createVNode(HeaderTextLinkButton, {
              name: child.name,
              url: getUrl(child),
              route: getRoute(child),
              block: ""
            }, null, 8, ["name", "url", "route"])
          ]))
        }), 128))
      : (_openBlock(), _createBlock(_component_RouterLink, {
          key: 1,
          class: _normalizeClass(["py-5 px-8 text-xl font-normal hover:cursor-pointer hover:no-underline", {'border-b-2 border-red-500': __props.navigation.name === _unref(router).currentRoute.value.name}]),
          to: _unref(route),
          target: _unref(url) ? '_blank' : undefined,
          href: _unref(url)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.navigation.name), 1)
          ]),
          _: 1
        }, 8, ["to", "target", "href", "class"]))
  ]))
}
}

})